import React from "react";
import "../Styles/Bills.css";
import { useNavigate } from "react-router-dom";


const Bills = () => {

  const navigate = useNavigate();

  return (
<div className="bills-page">
  <button className="back-button" onClick={() => navigate("/services")}>
    ← Back to Services
  </button>
  <div className="header-container">
    <h2>📥 Bill Payments</h2>
  </div>
      <p>
RCS makes it hastle free to pay ALL your bills under one roof! We believe in effortless and convenient service, 
therefore, enjoy haslte free and excellent response time in paying all your bills under one roof.

      </p>

      <p>
    RCS provides payment services for a wide range or billers not limited to:
  <ul className="mmg-bullet-list">
    <li>Guyana Power & light (GPL)</li>
    <li>Guyana Water Incorportion (GWI)</li>
    <li>E-Net</li>
    <li>IPED</li>
    <li>Courts</li>
    <li>Caripay</li>
    <li>University of Guyana</li>
    <li>GTT-Postpaid, Landline and fibre</li>
    <li>AND MANY MORE!</li>
  </ul>
      </p>
    </div>
    
  );
};

export default Bills;
